import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {loginApi} from '../api/login';
import {Router} from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],

})
export class LoginComponent implements OnInit {

  constructor(private _fb:FormBuilder,private router:Router) { }
  data:FormGroup
  showErr=false
  ngOnInit() {
    if(localStorage.getItem('type')){
      window.location.href='/home'
    }
    this.data=this._fb.group({
      email:['',Validators.required],
      password:['',Validators.required]
    })
  }
  async login(){
    let data=this.data.value
    let result=await loginApi(data)
    if(result){
      let admin=result.data.data
      localStorage.setItem("type",admin.type)
      localStorage.setItem("name",admin.name)
      localStorage.setItem("email",admin.email)
      localStorage.setItem("phone",admin.phone)
      localStorage.setItem("uni",admin.university)
      localStorage.setItem("token",admin.token)
      localStorage.setItem("_id",admin._id)
      localStorage.setItem("admin_image",admin.profile_photo)
      window.location.href='/home'
      // this.router.navigateByUrl('/')
      console.log('login')
    }else {
      this.showErr=true

      console.log('false')
    }
  }

}
